import BasicInfo from "../../../components/basic-info/BasicInfo";

interface IGroupEdu{
    data: IEducation
}

interface IEducation{
    level: string;
    endDate: string;
    startDate: string;
    institution: string;
    fieldOfStudy: string;
  }

export default function GroupEdu({data:{institution, fieldOfStudy, level, startDate, endDate}}: IGroupEdu){
    return (
        <div className="section">
            <div className="more-profile-info">
                <h4>Education</h4>

                <BasicInfo title="Institution" data={institution} />
                <BasicInfo title="Area Of Study" data={fieldOfStudy} />
                <BasicInfo title="Grade Level" data={level} />
                <BasicInfo title="Start Date" data={startDate} />
                <BasicInfo title="End Date" data={endDate} />

            </div>

        </div>
    )
}